import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { faInstagramSquare, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { fal } from './vendor/fontawesome/pro-light-svg-icons';
library.add(fas, far, fal, faInstagram, faInstagramSquare);
dom.watch();
